import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AlertDialog(props) {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Are you sure?'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Note that modifying Search Requirements will result in all current
          Luminaire Responses from suppliers being deleted, and the suppliers
          will have to re-submit Responses confirming that their Luminaires
          conform to the new Requirements. If you do not want to lose current
          Luminaire Responses, press CANCEL.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="">
          Cancel
        </Button>
        <Button onClick={props.confirmAction} color="" autoFocus>
          Confirm changes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
